/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicSynchronizeNirmata extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicSynchronizeNirmata");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicSynchronizeNirmata.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicSynchronizeNirmata>): BackgroundJobPayloadForPeriodicSynchronizeNirmata {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicSynchronizeNirmata(), model);
        BackgroundJobPayloadForPeriodicSynchronizeNirmata.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicSynchronizeNirmata>): BackgroundJobPayloadForPeriodicSynchronizeNirmata {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicSynchronizeNirmata.newInstance(<BackgroundJobPayloadForPeriodicSynchronizeNirmata> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicSynchronizeNirmata) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicSynchronizeNirmata.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicSynchronizeNirmata): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicSynchronizeNirmata.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
